import React from "react";
import capitalize from "lodash/capitalize";
import Modal from "../modal-new";
import embed from "embed-video";
import { S3_CDN_DOMAIN } from "../../constants";

class ExerciseLibraryVideoModal extends React.Component {
  isYoutubeVideo(url) {
    const youtubeRegex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/gm;
    const match = youtubeRegex.exec(url);
    if (match && match[1]) {
      return match[1];
    }
    return null;
  }

  render() {
    const { exercise } = this.props;
    const videoOriginal = this.props.exercise.video.videoOriginal?.replace(
      /\.[^/.]+$/,
      ".mp4"
    );
    const url = `${S3_CDN_DOMAIN}other_exercise_videos/${this.props.athleteId}/${videoOriginal}`;
    const youtubeVideo = this.isYoutubeVideo(exercise.video.url);

    const primaryMovements = ["Deadlift", "Squat", "Bench"];
    const isPrimary =
      exercise.movement && primaryMovements.includes(exercise.movement);

    return (
      <Modal
        className="one-video-modal"
        toClear={["exercise"]}
        title={
          exercise.primary === "assistant" || isPrimary
            ? exercise.movement
            : `${capitalize(exercise.primary)} (${exercise.movement})`
        }
      >
        <div className="body">
          {exercise.video && exercise.video.url ? (
            <>
              <div className="mb-6">
                <label>Exercise URL</label>
                <input
                  type="text"
                  className="url-input"
                  value={exercise.video.url}
                  readonly="readonly"
                />
              </div>
              <div className="exercise-library-video-iframe">
                <div
                  dangerouslySetInnerHTML={{
                    __html: youtubeVideo
                      ? embed.youtube(youtubeVideo, {
                          attr: { width: "100%", height: 478 },
                        })
                      : embed(exercise.video.url, {
                          attr: { width: "100%", height: 478 },
                        }),
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <a
                href={url}
                target="_blank"
                download="download"
                role="button"
                data-button-type="secondary"
                data-icon-only
                data-icon
              >
                <img
                  className="download-video-icon"
                  src="/img/icon-download.webp"
                />
              </a>

              <div className="exercise-library-video-iframe">
                <video
                  width="100%"
                  height="478"
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                  src={url}
                />
              </div>
            </>
          )}
        </div>
      </Modal>
    );
  }
}

export default ExerciseLibraryVideoModal;
